export { loadWijmoLocale } from './wijmo-i18n';

export async function initializeGlobals() {
	const [ wijmo, input, grid, gridFilter, gridGroupPanel, gridDetail, xlsx, gridXlsx ] = await Promise.all([
		import('@grapecity/wijmo'),
		import('@grapecity/wijmo.input'),
		import('@grapecity/wijmo.grid'),
		import('@grapecity/wijmo.grid.filter'),
		import('@grapecity/wijmo.grid.grouppanel'),
		import('@grapecity/wijmo.grid.detail'),
		import('@grapecity/wijmo.xlsx'),
		import('@grapecity/wijmo.grid.xlsx'),
	]);

	// eslint-disable-next-line max-len
	wijmo.setLicenseKey('Thomson Reuters*,815418578922576#B0P9ijIEJCLi4TPBFnU7IDUTtmMBxUcrskMV3iT0hWT6gEevYzRIRGRtV4bChGeCdUZrNnW7smWyIHOkhzYCFjcI9ENBxkamB7MwJGSltSZo9Ue6sUcwlGSml4b6M4Mshke996KzgzUxZGayUEakV4ZrwUbvFVZLZDTKZlNE94ZDhFRsl6Kyh7awNlcvVEN8glRv2CaNZjZoRGexU6cvJlY4cjTl34azRnUil7U68WZThHU8FHRWJzNCh4cwMja4EjeBlnYEFTNMVzLvpETYVGZp3mbZVjUkRWNalEVKR5Ux26YPNEOmlWeC9kN6JHcmpVQCNVRmhmb0dkdId4TsBjUvEzV7E5VMZnUSJFZIVUYwETWv3UcNRkVvlERnRDTl5mQyRnWZhWW8h6TC3kexJlctZmMn5mN7YFMVF5MXZXUxVFZUlGbH5Wb5MnS9JlUHhHSu3UTykXU9N6TjZWdPt6YiojITJCLiEzQ5QUN5IkNiojIIJCL5MTNwQzMzYTO0IicfJye&Qf35VfikEMyIlI0IyQiwiIu3Waz9WZ4hXRgACdlVGaThXZsZEIv5mapdlI0IiTisHL3JSNJ9UUiojIDJCLi86bpNnblRHeFBCIyV6dllmV4J7bwVmUg2Wbql6ViojIOJyes4nILdDOIJiOiMkIsIibvl6cuVGd8VEIgc7bSlGdsVXTg2Wbql6ViojIOJyes4nI4YkNEJiOiMkIsIibvl6cuVGd8VEIgAVQM3EIg2Wbql6ViojIOJyes4nIzMEMCJiOiMkIsISZy36Qg2Wbql6ViojIOJyes4nIVhzNBJiOiMkIsIibvl6cuVGd8VEIgQnchh6QsFWaj9WYulmRg2Wbql6ViojIOJyebpjIkJHUiwiI6EjM4gDMgAjMyEzMyAjMiojI4J7QiwiIqMnclRXdlJFIu36ct3GaUJiOiEmTDJCLiYzN5IjM9gzN5gTM4UTM8IiOiQWSiwSfdtlOicGbmJCLiIjdzIDMyIiOiIXZ6JCLlNHbhZmOiI7ckJye0ICfuBk');


	(window as any).wijmo = wijmo;
	(window as any).wijmo.collections = {
		// In the latest version of wijmo collections does not exist as a modules but part of the core module
		...wijmo,
	};
	(window as any).wijmo.grid = grid;
	(window as any).wijmo.input = input;
	(window as any).wijmo.xlsx = xlsx;
	(window as any).wijmo.grid.filter = gridFilter;
	(window as any).wijmo.grid.grouppanel = gridGroupPanel;
	(window as any).wijmo.grid.detail = gridDetail;
	(window as any).wijmo.grid.xlsx = gridXlsx;
}
